<template>
  <div>
    <input
      type="hidden"
      :name="inputName"
      :id="inputName"
      :value="phoneNumber"
    />
    <input
      type="hidden"
      :name="countryCodeInputName"
      :id="countryCodeInputName"
      :value="countryCode"
    />

    <MazInputPhoneNumber
      :search="false"
      :block="true"
      size="sm"
      class="mt-1"
      v-model="phoneNumber"
      :only-countries="['US', 'CA', 'MX']"
      v-model:country-code="countryCode"
      :required="true"
      @update="results = $event"
      :translations="{
        countrySelector: {
          placeholder: 'Country code',
          error: 'Choose country',
          searchPlaceholder: 'Search a country',
        },
        phoneInput: {
          placeholder: 'Enter your mobile phone number',
          example: 'Example: 8015555555',
        },
      }"
    />
  </div>
</template>

<script>
import MazInputPhoneNumber from "maz-ui/components/MazInputPhoneNumber";

export default {
  props: {
    inputName: {
      type: String,
      required: true,
    },
    countryCodeInputName: {
      type: String,
      required: true,
    },
    initialPhoneNumber: {
      type: String,
      default: "",
    },
  },
  components: {
    MazInputPhoneNumber,
  },
  data() {
    return {
      phoneNumber: this.initialPhoneNumber,
      countryCode: "US",
      results: null,
    };
  },
};
</script>

<style>
/* Force light mode - there may be a better maz-ui setting but this works */
.m-input-wrapper,
.m-input,
.m-input input,
.m-select-list,
.m-select-input,
.m-select-list__item,
button[class*="m-select"],
.m-input-tel__select button {
  --maz-color-bg-overlay: white !important;
  --maz-color-text: #1f2937 !important;
  --maz-border-color: #d1d5db !important;
  background-color: white !important;
  color: #1f2937 !important;
  border-color: #d1d5db !important;
}

.m-select-list__item:hover {
  background-color: #f3f4f6 !important;
}
</style>
